import type {
  ExperimentConfig,
  FeatureType,
} from '@seek/candidate-feature-flag';

export const REFINE_BAR_V2_FEATURE_FLAG =
  'experiment-dynamic-pills-v2-sticky-search-bar';
export const DynamicPillsV2 = 'dynamic-pills-v2';
export const StickySearchBar = 'sticky-search-bar';
export const RefineBarV2 = 'refine-bar-v2';
const refineBarV2Experiment = {
  key: REFINE_BAR_V2_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'Dynamic Pills v2 Sticky Search Bar',
  type: 'string',
  variations: [
    'control',
    DynamicPillsV2,
    StickySearchBar,
    RefineBarV2,
  ] as const,
} satisfies ExperimentConfig;
export type RefineBarV2Experiment = FeatureType<typeof refineBarV2Experiment>;

export const LOCATION_PROMPT_FEATURE_FLAG = 'experiment-location-prompt';
const locationPromptExperiment = {
  key: LOCATION_PROMPT_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'Location Prompt (Auto Focus Where Field)',
  type: 'string',
  variations: ['control', 'location-prompt'] as const,
} satisfies ExperimentConfig;
export type LocationPromptExperiment = FeatureType<
  typeof locationPromptExperiment
>;

export const SAVED_AND_RECENT_SEARCHES_FEATURE_FLAG =
  'experiment-saved-and-recent-searches';
const savedAndRecentSearchesExperiment = {
  key: SAVED_AND_RECENT_SEARCHES_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'Saved And Recent Searches',
  type: 'string',
  variations: ['control', 'saved-and-recent-searches'] as const,
} satisfies ExperimentConfig;
export type SavedAndRecentSearchesExperiment = FeatureType<
  typeof savedAndRecentSearchesExperiment
>;

export const BEHAVIOURAL_CUES_FILTERS_FEATURE_FLAG =
  'experiment-behavioural-cues-filters';
export const BehaviouralCuesFilters = 'bcuesFilters';
const behaviouralCuesFiltersExperiment = {
  key: BEHAVIOURAL_CUES_FILTERS_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'Behavioural Cues Filters',
  type: 'string',
  variations: ['control', BehaviouralCuesFilters] as const,
} satisfies ExperimentConfig;
export type BehaviouralCuesFiltersExperiment = FeatureType<
  typeof behaviouralCuesFiltersExperiment
>;

export const SERP_JOB_CARD_REDESIGN_FEATURE_FLAG =
  'experiment-serp-job-card-redesign';
export const JobCardRedesign = 'jobCardRedesign';
const serpJobCardRedesignExperiment = {
  key: SERP_JOB_CARD_REDESIGN_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'SERP Job Card Redesign',
  type: 'string',
  variations: ['control', JobCardRedesign] as const,
} satisfies ExperimentConfig;
export type SERPJobCardRedesignExperiment = FeatureType<
  typeof serpJobCardRedesignExperiment
>;

export const SEARCH_QUERY_CORRECTION_FEATURE_FLAG =
  'experiment-search-query-correction';
const searchQueryCorrectionExperiment = {
  key: SEARCH_QUERY_CORRECTION_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'Search Query Correction',
  type: 'string',
  variations: ['control', 'search-query-correction'] as const,
} satisfies ExperimentConfig;
export type SearchQueryCorrectionExperiment = FeatureType<
  typeof searchQueryCorrectionExperiment
>;

export const APPLICANT_INSIGHTS_NUMBER_OF_APPLICANTS_FEATURE_FLAG =
  'experiment-applicant-insights-number-of-applicants-jdv';
const applicationInsightNumberOfApplicantsExperiment = {
  key: APPLICANT_INSIGHTS_NUMBER_OF_APPLICANTS_FEATURE_FLAG,
  trackingNumber: 74,
  title: 'Applicant Insights Number Of Applicants',
  type: 'string',
  variations: ['control', 'count', 'volume'] as const,
} satisfies ExperimentConfig;
export type ApplicantInsightNumberOfApplicantsExperiment = FeatureType<
  typeof applicationInsightNumberOfApplicantsExperiment
>;

export const IN_FLOW_NUDGING_FEATURE_FLAG = 'experiment-in-flow-nudging';
export const InFlowNudgingWithoutCounts = 'in-flow-nudging-without-counts';
export const InFlowNudgingWithCounts = 'in-flow-nudging-with-counts';
const inFlowNudgingExperiment = {
  key: IN_FLOW_NUDGING_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'In-Flow Nudging',
  type: 'string',
  variations: [
    'control',
    InFlowNudgingWithoutCounts,
    InFlowNudgingWithCounts,
  ] as const,
} satisfies ExperimentConfig;
export type InFlowNudgingExperiment = FeatureType<
  typeof inFlowNudgingExperiment
>;

export const CAREER_FEED_COMPANY_EVP_FEATURE_FLAG =
  'experiment-career-feed-company-evp';
const careerFeedCompanyEvpExperiment = {
  key: CAREER_FEED_COMPANY_EVP_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'Career Feed Company EVP',
  type: 'string',
  variations: ['control', 'show'] as const,
} satisfies ExperimentConfig;
export type CareerFeedCompanyEvpExperiment = FeatureType<
  typeof careerFeedCompanyEvpExperiment
>;

export const JOB_SEARCH_ASSIST_FEATURE_FLAG = 'experiment-job-search-assist';
const jobSearchAssistExperiment = {
  key: JOB_SEARCH_ASSIST_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'Job Search Assist',
  type: 'string',
  variations: ['control', 'job-search-assist'] as const,
} satisfies ExperimentConfig;
export type JobSearchAssistExperiment = FeatureType<
  typeof jobSearchAssistExperiment
>;

export const CAREER_FEED_JOB_AI_SUMMARIES_FEATURE_FLAG =
  'experiment-career-feed-job-ai-summaries';
const careerFeedJobAiSummariesExperiment = {
  key: CAREER_FEED_JOB_AI_SUMMARIES_FEATURE_FLAG,
  trackingNumber: 68,
  title: 'Career Feed Job AI Summaries',
  type: 'string',
  variations: ['control', 'replace', 'all'] as const,
} satisfies ExperimentConfig;
export type CareerFeedJobAiSummariesExperiment = FeatureType<
  typeof careerFeedJobAiSummariesExperiment
>;

export const JDV_JOB_MATCH_ANALYSIS_FEATURE_FLAG =
  'experiment-jdv-job-match-llm';
const jdvJobMatchAnalysisExperiment = {
  key: JDV_JOB_MATCH_ANALYSIS_FEATURE_FLAG,
  trackingNumber: 72,
  title: 'JDV Job Match Analysis',
  type: 'string',
  variations: ['control', 'show'] as const,
} satisfies ExperimentConfig;
export type JobMatchAnalysisExperiment = FeatureType<
  typeof jdvJobMatchAnalysisExperiment
>;

export const experimentsToFetch: ExperimentConfig[] = [
  applicationInsightNumberOfApplicantsExperiment,
  behaviouralCuesFiltersExperiment,
  careerFeedCompanyEvpExperiment,
  careerFeedJobAiSummariesExperiment,
  inFlowNudgingExperiment,
  jobSearchAssistExperiment,
  locationPromptExperiment,
  refineBarV2Experiment,
  savedAndRecentSearchesExperiment,
  searchQueryCorrectionExperiment,
  serpJobCardRedesignExperiment,
  jdvJobMatchAnalysisExperiment,
];
